angular.module('app').component('testDetails', {
    bindings: {
        testDetails: '<',
        userDetails: '<'
    },
    templateUrl: 'scripts/app/partials/TraceDetails/TestDetails/test-details.tpl.html',
    controllerAs: 'vm',
    controller: function () {
        let vm = this;
        this.$onInit = function () {
            let testDetails = this.testDetails;
            let userDetails = this.userDetails;
            if (!angular.isUndefined(testDetails)) {
                vm.testDetails = testDetails;
            }
            if (!angular.isUndefined(userDetails)) {
                vm.testDetails = testDetails;
            }
        };
        this.$onChanges = function (changes) {
            if (angular.isUndefined(changes.testDetails)) {
                return;
            }
            if (angular.isUndefined(changes.userDetails)) {
                return;
            }
            vm.testDetails = changes.testDetails.currentValue;
            vm.userDetails = changes.userDetails.currentValue;
        };
    }
});
